import React, { useState, useEffect } from "react";
import InputMask from 'react-input-mask';
import close from "../imgs/icons/close.svg";

import bedB from '../imgs/icons/bedB.svg';
import Select from 'react-select';
import strutturaNode from 'node/struttura/struttura.js';
import stanzeNode from "node/stanze/stanze";
import delet from '../imgs/icons/delete.svg';
import modifica from '../imgs/icons/modifica.svg';
import confirmW from '../imgs/icons/confirmW.svg';
import magazzinoNode from "node/magazzino/magazzino";
import save from '../imgs/icons/save.svg';
import addW from '../imgs/icons/addW.svg';
import carica from '../imgs/icons/carica.svg';
import profiliNode from "node/profili/profili.js";
import allarmiNode from "node/allarmi/allarmi.js";

import lang from "../lang.json";

import AllarmiAssenza from "./AllarmiAssenza";
import Switch from "react-switch";


const langSet = lang[localStorage.getItem("lang")].scheda_stanza;
const sort = "id";
const order = "asc";
const SchedaStanza = (props) => {
    const [mod, setMod] = useState(0);
    const [status, setStatus] = useState(0);
    const [stanza, setStanza] = useState(props.stanza);
    const [letti, setLetti] = useState([]);
    const [sensori, setSensori] = useState([]);
    const [sensoriStanza, setSensoriStanza] = useState([]);
    const [sensoriSel, setSensoriSel] = useState([]);
    const [sensoriStanzaSel, setSensoriStanzaSel] = useState([]);
    const [sensoriRes, setSensoriRes] = useState([]);
    const [sensoriDel, setSensoriDel] = useState([]);
    const [sensoriStanzaDel, setSensoriStanzaDel] = useState([]);
    const [tipoSensori, setTipoSensori] = useState([]);
    const [tipoSensoriStanza, setTipoSensoriStanza] = useState([]);
    const [sensoriMag, setSensoriMag] = useState([]);
    const [sensoriStanzaMag, setSensoriStanzaMag] = useState([]);
    
    const [allarmiAssenzaambienteMod, setAllarmiAssenzaambienteMod] = useState([]);
    const [allarmiassenzaambiente, setallarmiassenzaambiente] = useState([]);
    const [allarmiAssenzaambienteDel, setAllarmiassenzaambienteDel] = useState([]);
    const [allarmiAssenzastanzaMod, setAllarmiAssenzastanzaMod] = useState([]);
    const [allarmiassenzastanza, setallarmiassenzastanza] = useState([]);
    const [allarmiAssenzastanzaDel, setAllarmiassenzastanzaDel] = useState([]);

    const accountData = JSON.parse(localStorage.getItem('account'));
    const [operation, setOperation] = useState();
    const [profili, setProfili] = useState([]);
    const [descrizione, setDescrizione] = useState("");
    const [alarms, setAlarms] = useState([]);
    const [idProfilo, setIdProfilo] = useState();
    const [allarmiDel, setAllarmiDel] = useState([]);
    const [allarmiSel, setAllarmiSel] = useState([]);
    const [allarmiCaduta, setAllarmiCaduta] = useState([]);
    const [allarmiCadutaMod, setAllarmiCadutaMod] = useState([]);
    const [allarmiCadutaDel, setAllarmiCadutaDel] = useState([]);

    const [searchTerm, setSearchTerm] = useState('');
    const [selectedOption, setSelectedOption] = useState(null);
    const filteredOptions = sensoriMag.filter((sensoremag) => { // filtra i sensori che hanno lo stesso tipo di quelli già selezionati in sensoriSel
        return !sensoriSel.some((sensore) => sensore.tipo === sensoremag.tipo);


    })
        ? sensoriMag.filter((sensoremag) => { // filtra i sensori che hanno lo stesso tipo di quelli già selezionati in sensoriSel
            return !sensoriSel.some((sensore) => sensore.tipo === sensoremag.tipo);


        }).filter((sensore) => {

            const sensoreText = `${sensore.nome} - ${sensore.tipo}`;
            return sensoreText.toLowerCase().includes(searchTerm.toLowerCase());
        })
            .map((sensore) => ({
                value: sensore.id,
                label: `${sensore.nome} - ${sensore.tipo}`,
            }))
        : [];
    const filteredOptionsStanza = sensoriStanzaMag.filter((sensoremag) => { // filtra i sensoriStanza che hanno lo stesso tipo di quelli già selezionati in sensoriStanzaSel
        return !sensoriStanzaSel.some((sensore) => sensore.tipo === sensoremag.tipo);


    })
        ? sensoriStanzaMag.filter((sensoremag) => { // filtra i sensoriStanza che hanno lo stesso tipo di quelli già selezionati in sensoriStanzaSel
            return !sensoriStanzaSel.some((sensore) => sensore.tipo === sensoremag.tipo);


        }).filter((sensore) => {

            const sensoreText = `${sensore.nome} - ${sensore.tipo}`;
            return sensoreText.toLowerCase().includes(searchTerm.toLowerCase());
        })
            .map((sensore) => ({
                value: sensore.id,
                label: `${sensore.nome} - ${sensore.tipo}`,
            }))
        : [];
    

    const defSelettore = "selettore selettoreFlex selettoreMiddle selettoreBorder";
    const selSelettore = "selettore selettoreFlex selettoreMiddle selettorePurple selettoreShadow";
    const defContinua = "selettore selettoreFlex selettoreBlue";
    const selettoreAllarmiassenzastanza = ['Nessun allarme', 'Allarme disabilitato', 'Allarme immediato', 'Allarme ritardato'];
    const selettoreAllarmiLetto = ['Nessun allarme', 'Allarme disabilitato', 'Allarme immediato', 'Allarme ritardato'];

    const doorSensors = ["Sensore porta accesso", "Sensore door0", "Sensore door1", "Sensore door2", "Sensore door3", "Sensore door4", "Sensore door5"];
    const hasDoorSensor = doorSensors.some(str => tipoSensoriStanza.includes(str));


    async function allarmiCadutaSwitch(id, mode, stato) {    //funzione per aggiungere, modificare o eliminare un allarme caduta
        try {
            props.loading(true);
            switch (mode) {
                case 'add': //? ---------- AGGIUNGI ALLARME CADUTA
                    setAllarmiCaduta([...allarmiCaduta, { descrizione: '', stato: '0', inizio: '', fine: '' }]);
                    break;
                case 'edit':        //? ---------- MODIFICA ALLARME CADUTA

                    let indexEdit = allarmiCadutaMod.findIndex((x) => x.id === id);
                    if (indexEdit === -1) {
                        setAllarmiCadutaMod([...allarmiCadutaMod, { id: id, stato: stato }]);
                    } else {
                        allarmiCadutaMod[indexEdit].stato = stato;
                        setAllarmiCadutaMod([...allarmiCadutaMod]);
                    }
                    break;
                case 'del': //? ---------- ELIMINA ALLARME CADUTA
                    let indexAllarme = allarmiCaduta.findIndex((x) => x.id === id); //trova l'indice dell'allarme da eliminare

                    if (indexAllarme !== -1) {  //se l'allarme è presente in allarmiCaduta
                        setAllarmiCadutaDel([...allarmiCadutaDel, allarmiCaduta[indexAllarme].id]);
                        allarmiCaduta.splice(indexAllarme, 1);
                        setAllarmiCaduta([...allarmiCaduta]);
                    }
                    break;
                default:
                    break;
            }
            props.loading(false);
            return;
        } catch (e) {
            console.log(e);
            return;
        }
    }

    async function getAllarmiCaduta() { //funzione per recuperare gli allarmi caduta
        props.loading(true);
        let id_sensore = sensori.filter((item) => item.tipo === "Sensore caduta")[0].id_sensore; //trova l'id del sensore caduta
        await allarmiNode.getAllarmiCaduta(accountData.token, id_sensore).then((res) => {
            setAllarmiCaduta(res.data);
            console.log(res.data)
        }).finally(() => {
            props.loading(false);
        });
    }

    async function createLetti() {
        setLetti([]);
        for (let i = 0; i < props.stanza.num_letti - 1; i++) {
            if (props.stanza.id_residenti.length < i) {
                setLetti(current => [...current, { id: i, stato: 'Occupato', residente: props.stanza.id_residenti[i] }]);
            } else {
                setLetti(current => [...current, { id: i, stato: 'Libero' }]);
            }
        }
        setStatus(1);
    }

    function openProfiloPopup(operation) {
        getProfili();
        setOperation(operation);
        let profPop = document.getElementById("ProfiloPopup").style.display;
        if (profPop === "none") {
            document.getElementById("ProfiloPopup").style.display = "flex";
        } else {
            document.getElementById("ProfiloPopup").style.display = "none";
        }
    }
    async function getallarmiassenzaambiente() {
        props.loading(true);
        let id_sensore = sensori.filter((item) => item.tipo === "Sensore presenza stanza")[0].id_sensore;
        allarmiNode.getAllarmiOccupazioneStanza(accountData.token, id_sensore).then((res) => {
            setallarmiassenzaambiente(res.data);
        }).finally(() => {
            props.loading(false);
        });
    }
    async function getallarmiassenzastanza() {
        props.loading(true);
        // console.log(sensoriStanza)
        const id_sensori = sensoriStanza.filter(item =>
                        doorSensors.includes(item.tipo)
                    );
        const idList = id_sensori.map(item => item.id_sensore);
        // console.log(idList)
        Promise.all(
            idList.map(id =>
                allarmiNode.getAllarmiOccupazioneStanza(accountData.token, id)
            )
        ).then(results => {
            const concatenated = results.flatMap(res => res.data);
            setallarmiassenzastanza(concatenated);
        }).catch(err => {
            console.error("❌ Error fetching alarms:", err);
        }).finally(() => {
            // console.log(allarmiassenzastanza)
            props.loading(false); // Runs once when all requests are done
        });
    }
    function openProfiloPopup(operation) {
        getProfili();
        setOperation(operation);
        let profPop = document.getElementById("ProfiloPopup").style.display;
        if (profPop === "none") {
            document.getElementById("ProfiloPopup").style.display = "flex";
        } else {
            document.getElementById("ProfiloPopup").style.display = "none";
        }
    }
    
    async function getProfili() {
        props.loading(true);
        let tipo = status === 4 ? "Sensore presenza stanza" :  null;
        await profiliNode.getProfili(accountData.token, tipo).then((res) => {
            setProfili(res.data);
        }).finally(() => {
            props.loading(false);
        });
    }

    useEffect(() => {
        getProfili();
    }, [status >= 3]);

    async function creaProfilo() {
        props.loading(true);
        let tipo = status === 3 ? "Sensore geofencing" : status === 4 ? "Sensore letto" : status === 5 ? "Sensore caduta" : null;
        await profiliNode.creaProfilo(accountData.token, descrizione, tipo, alarms).finally(() => {
            getProfili();
            openProfiloPopup();
            props.loading(false);
        });
    }

    async function loadProfilo() {
        props.loading(true);
        let tipo = status === 3 ? "Sensore geofencing" : status === 4 ? "Sensore letto" : status === 5 ? "Sensore caduta" : null;
        await allarmiNode.caricaProfilo(accountData.token, idProfilo, sensoriRes.filter((item) => item.tipo === tipo)[0].id_sensore).then((res) => {
            console.log(res)
            if (status === 5) { getallarmiassenzaambiente(); getallarmiassenzastanza();} // è giusto 5????
        }
        ).finally(() => {
            openProfiloPopup();
            props.loading(false);
        });
    }

    const profilopopup = (
        <div id="ProfiloPopup" className="popupContent merda" style={{ display: "none", position: "absolute", top: "45%", left: "45%", transform: "translate(-50%, -50%)", }}>
            <div id="PopupBody" style={{ width: "30em" }}>
                <div style={{ padding: "1.5em", display: operation !== "salva" ? "none" : "" }}>
                    <label>Nome profilo da salvare</label>
                    <input
                        type="text"
                        placeholder={langSet.inserisciNome}
                        onChange={(e) => setDescrizione(e.target.value)}
                        style={{ width: "90%", margin: "1em" }}
                    />
                </div>
                <div style={{ padding: "1.5em", display: operation !== "carica" ? "none" : "" }}>
                    <label>Scegli profilo da caricare</label>
                    <select defaultValue="0" style={{ width: "99%", margin: "1em", padding: "0px" }} onChange={(e) => setIdProfilo(e.target.value)}>
                        <option value="0" disabled>Seleziona un profilo</option>
                        {profili.map((profilo, i) => {
                            return (<option key={i} value={profilo.id}>{profilo.descrizione}</option>);
                        })}
                    </select>
                </div>
                <div id="PopupFooter">
                    <div className="selettore selettoreFlex selettoreViolet" onClick={() => openProfiloPopup()}>
                        <p>{langSet.annulla}</p>
                        <img src={close} alt="close" />
                    </div>
                    <div className="selettore selettoreFlex selettoreBlue" onClick={() => { operation === "salva" ? creaProfilo() : loadProfilo() }}>
                        <p>{langSet.salva}</p>
                        <img src={confirmW} alt="confirm" />
                    </div>
                </div>
            </div>
        </div>
    );
    async function salvaModifiche(what) {
        try {
            let response; 
            switch (what) {
                case "deleteAllarmi":
                    if (allarmiDel.length > 0) {
                        for (let i = 0; i < allarmiSel.length; i++) {
                            if (allarmiDel[i] !== undefined) {
                                response = await allarmiNode.deleteAllarme(accountData.token, allarmiDel[i]);
                                if (!response.result) throw response.error;
                            }
                        }
                    }
                    break;
                case 'sensori':
                    if (sensoriDel.length > 0) {
                        
                        for (let i = 0; i < sensoriDel.length; i++) {
                            await stanzeNode.removeSensorAmbiente(accountData.token, props.stanza.id, sensoriDel[i].id_sensore);
                        }
                    }
                    if (sensoriSel.length > 0) {
                        // console.log(sensoriSel)
                        for (let i = 0; i < sensoriSel.length; i++) {
                            await stanzeNode.addSensorAmbiente(accountData.token, props.stanza.id, sensoriSel[i].id);
                        }
                    }
                    break;

                case 'sensori-stanza':
                    if (sensoriStanzaDel.length > 0) {

                        for (let i = 0; i < sensoriStanzaDel.length; i++) {
                            await stanzeNode.removeSensorStanza(accountData.token, props.stanza.id, sensoriStanzaDel[i].id_sensore);
                        }
                    }
                    if (sensoriStanzaSel.length > 0) {
                        // console.log(sensoriStanzaSel)
                        for (let i = 0; i < sensoriStanzaSel.length; i++) {
                            await stanzeNode.addSensorStanza(accountData.token, props.stanza.id, sensoriStanzaSel[i].id);
                        }
                    }
                    break;
                 
                case 'allarmipresenzaAmbiente':
                    //TODO/* -------------------- FUNZIONE PER ELIMINAZIONE ALLARMI PRESENZA AMBIENTE -------------------- */
                    for (let allarme_id of allarmiAssenzaambienteDel) {
                        if (allarme_id === undefined) continue;
                        if (allarme_id !== undefined) response = await allarmiNode.deleteAllarme(accountData.token, allarme_id);
                    }

                    //?/* -------------------- RECUPERO ID SENSORE PRESENZA AMBIENTE -------------------- */

                    var id_sensore = sensori.filter((item) => item.tipo === "Sensore presenza stanza")[0].id_sensore;

                    //?/* -------------------- FUNZIONE PER AGGIUNTA ALLARMI PRESENZA AMBIENTE -------------------- */
                    var nuoviAllarmi = [];

                    for (let allarme of allarmiassenzaambiente) {
                        if (allarme.id || allarme.stato === 'Nessun allarme') continue;

                        allarme.id_sensore = id_sensore;
                        allarme.giorni = [0, 1, 2, 3, 4, 5, 6];
                        allarme.id_piani = [stanza.percorso.split('|')[0].split(' ')[0]];
                        allarme.tipo = 'allarme';
                        allarme.lingua = 'it';

                        switch (allarme.stato) {
                            case 'Allarme disabilitato':
                                allarme.valore = { presenceDetected: false };
                                allarme.abilitato = false;
                                allarme.messaggio = 'la stanza è vuota';
                                allarme.ritardo = false;
                                break;
                            case 'Allarme immediato':
                                allarme.valore = { presenceDetected: false };
                                allarme.abilitato = true;
                                allarme.messaggio = 'la stanza è vuota';
                                allarme.ritardo = false;
                                break;
                            case 'Allarme ritardato':
                                allarme.valore = { presenceDetected: false };
                                allarme.abilitato = true;
                                allarme.messaggio = 'la stanza è vuota';
                                allarme.ritardo = true;
                                break;
                            default:
                                break;
                        }

                        nuoviAllarmi.push(allarme);
                    }
                    getallarmiassenzaambiente();
                    
                    if (nuoviAllarmi.length > 0) response = await allarmiNode.addAllarme(accountData.token, nuoviAllarmi);
                    //?/* -------------------- FUNZIONE PER MODIFICA ALLARMI PRESENZA AMBIENTE -------------------- */
                    for (let allarmeMod of allarmiAssenzaambienteMod) {
                        response = await allarmiNode.patchStatoAllarme(accountData.token, allarmeMod.id, allarmeMod.stato);
                    }

                    await getallarmiassenzaambiente();
                    break;
    
                    break;
                case 'allarmipresenzaStanza':
                    //TODO/* -------------------- FUNZIONE PER ELIMINAZIONE ALLARMI PRESENZA STANZA (door) -------------------- */
                    for (let allarme_id of allarmiAssenzastanzaDel) {
                        if (allarme_id === undefined) continue;
                        if (allarme_id !== undefined) response = await allarmiNode.deleteAllarme(accountData.token, allarme_id); // !!!!!
                    }

                    //?/* -------------------- RECUPERO ID SENSORE PRESENZA STANZA (door) -------------------- */

                    console.log(allarmiassenzastanza)

                    //?/* -------------------- FUNZIONE PER AGGIUNTA ALLARMI PRESENZA STANZA (door) -------------------- */
                    var nuoviAllarmi = [];

                    for (let allarme of allarmiassenzastanza) {
                        if (allarme.id || allarme.stato === 'Nessun allarme') continue;

                        allarme.giorni = [0, 1, 2, 3, 4, 5, 6];
                        allarme.id_piani = [stanza.percorso.split('|')[0].split(' ')[0]];
                        allarme.lingua = 'it';

                        if (allarme.messaggio === 'uscita dalla stanza') {
                            allarme.tipo = (allarme.doorEvent === 'Exit') 
                                           ? 'leaving_sensor_room' 
                                           : 'leaving_room';
                        } else {
                            allarme.tipo = (allarme.doorEvent === 'Exit') 
                                           ? 'entering_room' 
                                           : 'entering_sensor_room';
                        }
                        allarme.valore = { door: allarme.doorEvent};
                        allarme.ritardo = false;
                        allarme.abilitato = !(allarme.stato == false);

                        nuoviAllarmi.push(allarme);
                    }
                    getallarmiassenzastanza();

                    if (nuoviAllarmi.length > 0) response = await allarmiNode.addAllarme(accountData.token, nuoviAllarmi); // !!!!!
                    //?/* -------------------- FUNZIONE PER MODIFICA ALLARMI LETTO -------------------- */
                    for (let allarmeMod of allarmiAssenzastanzaMod) {
                        response = await allarmiNode.patchStatoAllarme(accountData.token, allarmeMod.id, allarmeMod.stato); // !!!!! ?
                    }

                    await getallarmiassenzastanza();
                    break;

                    break;
                case 'sensori':
                    break;
                case 'allarmiCaduta':
                    //TODO/* -------------------- FUNZIONE PER ELIMINAZIONE ALLARMI LETTO -------------------- */
                    for (let allarme_id of allarmiCadutaDel) {
                        if (allarme_id === undefined) continue;
                        if (allarme_id !== undefined) response = await allarmiNode.deleteAllarme(accountData.token, allarme_id);
                    }

                    //?/* -------------------- RECUPERO ID SENSORE LETTO -------------------- */

                    var id_sensore = sensori.filter((item) => item.tipo === "Sensore caduta")[0].id_sensore;

                    //?/* -------------------- FUNZIONE PER AGGIUNTA ALLARMI LETTO -------------------- */
                    var nuoviAllarmi = [];

                    for (let allarme of allarmiCaduta) {
                        if (allarme.id || allarme.stato === 'Nessun allarme') continue;

                        allarme.id_sensore = id_sensore;
                        allarme.giorni = [0, 1, 2, 3, 4, 5, 6];
                        allarme.id_piani = [props.stanza.percorso.split('|')[0].split(' ')[0]];
                        allarme.tipo = 'allarme';
                        allarme.lingua = 'it';

                        switch (allarme.stato) {
                            case 'Allarme disabilitato':
                                allarme.valore = { status: 'fall_detected' };
                                allarme.abilitato = false;
                                allarme.messaggio = 'Il paziente è caduto';
                                allarme.ritardo = false;
                                break;
                            case 'Allarme immediato':
                                allarme.valore = { status: 'fall_detected' };
                                allarme.abilitato = true;
                                allarme.messaggio = 'Il paziente è caduto';
                                allarme.ritardo = false;
                                break;
                            case 'Allarme ritardato':
                                allarme.valore = { status: 'fall_detected' };
                                allarme.abilitato = true;
                                allarme.messaggio = 'Il paziente è caduto';
                                allarme.ritardo = true;
                                break;
                            default:
                                break;
                        }

                        nuoviAllarmi.push(allarme);
                    }
                    
                    if (nuoviAllarmi.length > 0) response = await allarmiNode.addAllarme(accountData.token, nuoviAllarmi);

                    //?/* -------------------- FUNZIONE PER MODIFICA ALLARMI LETTO -------------------- */
                    for (let allarmeMod of allarmiCadutaMod) {
                        response = await allarmiNode.patchStatoAllarme(accountData.token, allarmeMod.id, allarmeMod.stato);
                    }

                    await getAllarmiCaduta();
                    break;
                case 'letti':
                    break;
                default:
                    break;
            }


            setSensoriSel([]);
            setSensoriDel([]);
            setSensoriStanzaSel([]);
            setSensoriStanzaDel([]);
            setAllarmiSel([]);
            setAllarmiDel([]);

            setMod(0);
            props.loading(false);

            
        } catch (e) {
            console.log(e);
        }                
    }

    function Sens(azione, id) {
        //trova l'id del sensore in sensoriMa
        //! MODIFICATO DA SIMO, NON ELIMINARE IN MERGE GRAZIE
        if (azione === 'add') {
            setSensoriSel([...sensoriSel, sensoriMag.filter((item) => item.id === id)[0]]);
            setSensori([...sensori, sensoriMag.filter((item) => item.id === id)[0]]);
            setTipoSensori([...tipoSensori, sensoriMag.filter((item) => item.id === id)[0].tipo]);
        } else {
            let index;
            index = sensori.findIndex((x) => x.id_sensore === id);
            setSensoriDel([...sensoriDel, index !== -1 ? sensori.filter((item) => item.id_sensore === id)[0] : sensori.filter((item) => item.id === id)[0]]);
            let indexTipo = tipoSensori.indexOf(sensori[index].tipo);
            tipoSensori.splice(indexTipo, 1);
            setTipoSensori([...tipoSensori]);

            sensori.splice(index, 1);
            setSensori([...sensori]);
            for (let sensoresel in sensoriSel) {
                if (sensoresel.id_sensore === id) {
                    index = sensoriSel.findIndex((x) => x.id_sensore === id);
                    sensoriSel.splice(index, 1);
                    setSensoriSel([...sensoriSel]);
                }
            }
        }
    }

    function SensStanza(azione, id) {
        //trova l'id del sensore in sensoriMa
        //! MODIFICATO DA SIMO, NON ELIMINARE IN MERGE GRAZIE
        if (azione === 'add') {
            setSensoriStanzaSel([...sensoriStanzaSel, sensoriStanzaMag.filter((item) => item.id === id)[0]]);
            setSensoriStanza([...sensoriStanza, sensoriStanzaMag.filter((item) => item.id === id)[0]]);
            setTipoSensoriStanza([...tipoSensoriStanza, sensoriStanzaMag.filter((item) => item.id === id)[0].tipo]);
        } else {
            let index;
            index = sensoriStanza.findIndex((x) => x.id_sensore === id);
            setSensoriStanzaDel([...sensoriStanzaDel, index !== -1 ? sensoriStanza.filter((item) => item.id_sensore === id)[0] : sensoriStanza.filter((item) => item.id === id)[0]]);
            let indexTipo = tipoSensoriStanza.indexOf(sensoriStanza[index].tipo);
            tipoSensoriStanza.splice(indexTipo, 1);
            setTipoSensoriStanza([...tipoSensoriStanza]);

            sensoriStanza.splice(index, 1);
            setSensoriStanza([...sensoriStanza]);
            for (let sensoresel in sensoriStanzaSel) {
                if (sensoresel.id_sensore === id) {
                    index = sensoriStanzaSel.findIndex((x) => x.id_sensore === id);
                    sensoriStanzaSel.splice(index, 1);
                    setSensoriStanzaSel([...sensoriStanzaSel]);
                }
            }
        }
    }

    async function GetStanza(token, id) {  //!esempio controllo scheda in scheda
        props.loading(true);
        let piano = props.stanza.percorso.split(' | ')[0];
        let ala = props.stanza.percorso.split(' | ')[1];
        let corridoio = props.stanza.percorso.split(' | ')[2];
        await strutturaNode.getStrutturaAll(token).then((res) => {
            if(!res.result) throw res.error;
            res.data.map((p) => {
                if (piano === p.id)
                    p[piano].map((a) => {
                        if (ala === a.id)
                            a[ala].map((c) => {
                                if (corridoio === c.id)
                                    c[corridoio].map((s) => {
                                        if (id === s.id)
                                            setStanza(s);
                                        setStanza(current => ({ ...current, percorso: props.stanza.percorso }));
                                        //props.loading(false);
                                    })
                            })
                    })
            });
        }).catch((e) => props.SchedaInScheda('alarm', e.toString(), 'ritorna_stanza', props.stanza)).finally(() => props.loading(false));
    }

    async function getSensori() {
        props.loading(true);
        //prendi tutti i sensori dal magazzino struttura 
        await magazzinoNode.getMagazzinoStruttura(accountData.token, sort, order).then((res) => {
            if(!res.result) throw res.error;
            const skippingTipi = ["AA", "Pulsante"];
            setSensoriMag(
              (res.data ?? []).filter(sensor =>
                !skippingTipi.includes(sensor.tipo)
              )
            );
        }).catch((e) => props.SchedaInScheda('scheda_stanza', e.toString(), 'sensori', sensori)).finally(() => props.loading(false));
    }

    async function getSensoriStanza() {
        props.loading(true);
        //prendi tutti i sensori dal magazzino struttura 
        await magazzinoNode.getMagazzinoStruttura(accountData.token, sort, order).then((res) => {
            if(!res.result) throw res.error;
            const skippingTipi = ["AA", "Pulsante"];
            setSensoriStanzaMag(
              (res.data ?? []).filter(sensor =>
                !skippingTipi.includes(sensor.tipo)
              )
            );
        }).catch((e) => props.SchedaInScheda('scheda_stanza', e.toString(), 'sensori', sensoriStanza)).finally(() => props.loading(false));
    }

    async function GetSensoriAmbiente() {
        props.loading(true);
        await stanzeNode.getSensoriAmbiente(accountData.token, props.stanza.id).then((res) => {
            if(!res.result) throw res.error;
            setSensori(res.data);
            let temp = [];
            for (let i = 0; i < res.data.length; i++) {
                temp.push(res.data[i].tipo);
            }
            setTipoSensori(temp);
        }).catch((e) => props.SchedaInScheda('scheda_stanza', e.toString(), 'sensori_stanza', sensori)).finally(() => props.loading(false));
    }

    async function GetSensoriStanza() {
        props.loading(true);
        await stanzeNode.getSensoriStanza(accountData.token, props.stanza.id).then((res) => {
            if(!res.result) throw res.error;
            setSensoriStanza(res.data);
            let temp = [];
            for (let i = 0; i < res.data.length; i++) {
                temp.push(res.data[i].tipo);
            }
            setTipoSensoriStanza(temp);
        }).catch((e) => props.SchedaInScheda('scheda_stanza', e.toString(), 'sensori_stanza', sensoriStanza)).finally(() => props.loading(false));
    }

    async function allarmiassenzaambienteSwitch(id, mode, stato) {
        try {
            props.loading(true);
            switch (mode) {
                case 'add':
                    setallarmiassenzaambiente([...allarmiassenzaambiente, { descrizione: '', stato: '0', inizio: '', fine: '' }]);
                    break;
                case 'edit':

                    let indexEdit = allarmiAssenzaambienteMod.findIndex((x) => x.id === id);
                    if (indexEdit === -1) {
                        setAllarmiAssenzaambienteMod([...allarmiAssenzaambienteMod, { id: id, stato: stato }]);
                    } else {
                        allarmiAssenzaambienteMod[indexEdit].stato = stato;
                        setAllarmiAssenzaambienteMod([...allarmiAssenzaambienteMod]);
                    }
                    break;
                case 'del':
                    let indexAllarme = allarmiassenzaambiente.findIndex((x) => x.id === id);

                    if (indexAllarme !== -1) {
                        setAllarmiassenzaambienteDel([...allarmiAssenzaambienteDel, allarmiassenzaambiente[indexAllarme].id]);
                        allarmiassenzaambiente.splice(indexAllarme, 1);
                        setallarmiassenzaambiente([...allarmiassenzaambiente]);
                    }
                    break;
                default:
                    break;
            }
            props.loading(false);
            return;
        } catch (e) {
            console.log(e);
            return;
        }
    }

    async function allarmiassenzastanzaSwitch(options) {
        try {
            props.loading(true);
            const mode = options.mode;
            switch (mode) {
                case 'add':
                    const id_sensore = options.id;
                    const doorEvent = options.direction;
                    const alarmString = options.alarm;
                    setallarmiassenzastanza([...allarmiassenzastanza, 
                        { descrizione: '', id_sensore: id_sensore, stato: '0', 
                          doorEvent: doorEvent, messaggio: alarmString,
                          inizio: '', fine: '' }]);
                    break;
                case 'edit':
                    const id_edit = options.id_edit
                    const stato = options.stato;
                    let indexEdit = allarmiAssenzastanzaMod.findIndex((x) => x.id === id_edit);
                    if (indexEdit === -1) {
                        setAllarmiAssenzastanzaMod([...allarmiAssenzastanzaMod, { id: id_edit, stato: stato }]);
                    } else {
                        allarmiAssenzastanzaMod[indexEdit].stato = stato;
                        setAllarmiAssenzastanzaMod([...allarmiAssenzastanzaMod]);
                    }
                    break;
                case 'del':
                    const id_remove = options.id_remove;
                    let indexAllarme = allarmiassenzastanza.findIndex((x) => x.id === id_remove);

                    if (indexAllarme !== -1) {
                        setAllarmiassenzastanzaDel([...allarmiAssenzastanzaDel, allarmiassenzastanza[indexAllarme].id]);
                        allarmiassenzastanza.splice(indexAllarme, 1);
                        setallarmiassenzastanza([...allarmiassenzastanza]);
                    }
                    break;
                default:
                    break;
            }
            props.loading(false);
            return;
        } catch (e) {
            console.log(e);
            return;
        }
    }


    useEffect(() => {
        getSensori()
        getSensoriStanza()
        GetSensoriAmbiente()
        GetSensoriStanza()
        setMod(0);
        setStatus(0);
        setStanza(props.stanza);
        setLetti([]);

        if ( props.stanza.letti[0] === undefined || props.stanza.letti[0].stato === undefined) GetStanza(accountData.token, props.stanza.id); //!esempio controllo scheda in scheda
    }, [props]);

    return (
        <>
            <div id="Header" className="headerPopup" style={{ justifyContent: "start", overflowY: "auto" }}>
                <div className={status === 0 ? selSelettore : defSelettore} onClick={() => setStatus(0)}>
                    <p>{langSet.dettagli}</p>
                </div>
                <div className={status === 1 ? selSelettore : defSelettore}style={props.stanza.num_letti === "0" || props.stanza.num_letti === null ? {display: "none"} : {display:"block"}} onClick={() => createLetti(1)}>
                    <p>{langSet.statoLetti}</p>
                </div>
                <div className={status === 2 ? selSelettore : defSelettore}   onClick={() => setStatus(2)} >
                    <p>{"Sensori Ambiente"}</p>
                </div>
                <div className={status === 3 ? selSelettore : defSelettore}   onClick={() => setStatus(3)} >
                    <p>{"Sensori Stanza"}</p>
                </div>
                <div className={status === 5 
                                    ? selSelettore 
                                    : tipoSensori.includes("Sensore caduta") 
                                        ? defSelettore 
                                        : "disabled " + defSelettore
                               } 
                     onClick={tipoSensori.includes("Sensore caduta") 
                                ? async () => { await getAllarmiCaduta(); setStatus(5) } 
                                : null
                             }
                >
                    <p>{"Allarmi Caduta"}</p>
                </div>
                <div
                    className={
                        status === 6
                            ? selSelettore
                            : hasDoorSensor
                                ? defSelettore
                                : "disabled " + defSelettore
                    }
                    onClick={
                        hasDoorSensor
                            ? async () => {
                                await getallarmiassenzastanza();
                                setStatus(6);
                            }
                            : null
                    }
                >
                    <p>Allarmi Stanza</p>
                </div>
            </div>
            <div id="PopupBody">
                {/* DETTAGLI */}
                <table className="scheda" style={{ display: status === 0 ? "" : "none" }}>
                    <tbody>
                        <tr>
                            <td width="15%" rowSpan={2} className="schedaImg">
                                {langSet.stanzaN}
                                <p style={{ fontSize: "4em", margin: 0 }}>{props.stanza.id}</p>
                                <div style={{ fontSize: ".75em", display: "flex", alignItems: "center", padding: "0 2em" }}>
                                    {stanza.letti.map((letto, i) => {

                                        return (
                                            <>
                                                {
                                                    letto.stato === 'Occupato' ?
                                                        <div key={i} className='dot blue medium'>&nbsp;</div>
                                                        :
                                                    letto.stato === 'Libero' ?
                                                        <div key={i} className='dot green medium'>&nbsp;</div>
                                                        :
                                                    null
                                                }
                                            </>
                                        )
                                    })}
                                    <img src={bedB} alt='bed' style={{ width: "1em" }} />&nbsp;x2
                                </div>
                            </td>
                            <td width="85%">
                                <label>{langSet.posizione}</label>
                                <p>{stanza.percorso}</p>
                            </td>
                        </tr>
                    </tbody>
                </table>

                {/* STATO LETTI */}
                <div style={{ display: status === 1 ? "" : "none" }}> {/* stato letti */}
                    <table id="TitoliLista" >
                        <tbody>
                            <tr>
                                <td width="20%" style={{ border: 0 }}>{langSet.letto} </td>
                                <td width="20%" style={{ border: 0 }}>{langSet.stato} </td>
                                <td width="60%" style={{ border: 0 }}>{langSet.residente} </td>
                            </tr>
                        </tbody>
                    </table>
                    {stanza.letti.map((letto, i) => {
                        // console.log(letto);
                        return (
                            <table key={i} id="Lista" style={{ border: 0 }}>
                                <tbody>
                                    <tr>
                                        <td width="20%" >{i + 1}</td>
                                        <td width="20%" > {letto.stato === 'Occupato' ? <div className='dot blue medium normPosition' /> : letto.stato === 'Libero' ? <div className='dot green medium normPosition' /> : <></>} &nbsp;&nbsp; {letto.stato === 'Occupato' ? langSet.occupato : langSet.libero}</td>
                                        <td width="60%" >{letto.residente}</td>
                                    </tr>
                                </tbody>
                            </table>
                        )
                    })}
                </div>

                {/* SENSORI AMBIENTE */}
                <div style={{ display: status === 2 ? "" : "none" }}>
                    <table id="TitoliLista" >
                        <tbody>
                            <tr>
                                <td width="15%" style={{ border: 0 }}>{langSet.nome} </td>
                                <td width="15%" style={{ border: 0 }}>ID </td>
                                <td width="15%" style={{ border: 0 }}>{langSet.tipo} </td>
                                <td width="15%" style={{ border: 0 }}>{langSet.stato} </td>
                                <td width="15%" style={{ border: 0 }}>{langSet.batteria} </td>
                                <td width="25%" style={{ border: 0 }}></td>
                            </tr>
                        </tbody>
                    </table>
                     <Select id="Select" isDisabled={mod === 0 ? true : false}
                        styles={{
                            control: (provided) => ({ ...provided, width: '300px', fontSize: "90%", color: "#2B318A", fontWeight: "600", borderRadius: "20px", 
                                                    overflowX: "hidden", boxShadow: "none", "&:hover": { borderRadius: "25px", boxShadow: "none", width:"300px" } }),
                            input: (provided) => ({ ...provided, color: "#2B318A", fontWeight: "600", fontSize: "90%", textAlign:"center", marginLeft:"10px" }),
                            menu: (provided) => ({ ...provided, width: '300px', fontSize: "90%", color: "#2B318A", fontWeight: "600", borderRadius: "20px", 
                                                    boxShadow: "none",  border: "solid 1px #2B318A", overflowX: "hidden", 
                                                    "&:hover": { borderRadius: "25px", boxShadow: "none", width:"300px" } }),
                            option: (provided) => ({ ...provided, color: "#2B318A", fontWeight: "600", fontSize: "90%", textAlign:"center", marginLeft:"10px", 
                                                    overflowY: "scroll", maxHeight: "25em", overflowX: "hidden"}),
                            menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999
                            })
                          }}
                        menuPortalTarget={document.body}
                        options={filteredOptions}
                        value={selectedOption}
                        onChange={(selected) => {setSelectedOption(selected); Sens("add", selected.value)}}
                        placeholder={langSet.selezionaSensore}
                        isSearchable
                        onInputChange={(inputValue) => setSearchTerm(inputValue)}
                        /><i style={{ fontSize: "90%", color: "#d3d3d3", display: mod === 1 ? "" : "none" }}>* {langSet.massimo1PerTipologia}</i>
                    <div style={{ overflow: "scroll", maxHeight: "25em" }}>
                        {sensori.length > 0 ?
                            sensori.map((sensore, i) => (
                                <table id="Lista" key={i}>
                                    <tbody>
                                        <tr key={sensore}>
                                            <td width="15%" style={{ padding: 0, paddingLeft: ".5em" }}>{sensore.nome}</td>
                                            <td width="15%" style={{ padding: 0, paddingLeft: ".5em" }}>{sensore.id_sensore ?? sensore.id}</td>
                                            <td width="15%" style={{ padding: 0, paddingLeft: ".5em" }}>{sensore.tipo}</td>
                                            <td width="15%" style={{ padding: 0, paddingLeft: ".5em" }}>{sensore.stato}</td>
                                            <td width="15%" style={{ padding: 0, paddingLeft: ".5em" }}>{sensore.batteria}</td>
                                            <td width="25%" style={{ padding: 0, paddingLeft: ".5em" }}>
                                                {mod === 0 ? null :
                                                    <div className="selettore selettoreFlex selettoreViolet" onClick={() => Sens("del", sensore.id_sensore)}>
                                                        <p>{langSet.disassocia}</p>
                                                        <img src={delet} alt="delete" />
                                                    </div>
                                                }
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            )) : <p style={{ textAlign: "center", margin: "1em", display: "" }}>{langSet.nessunSensore}</p>
                        }
                    </div>
                    <div className="navigators">
                        {mod === 0 ?
                            <div
                                className="selettore selettoreFlex selettoreViolet"
                                onClick={() => setMod(1)}
                                style={{ display: accountData.tipo === 4 ? "none" : null }}
                            >
                                <p>{langSet.modifica}</p>
                                <img src={modifica} alt='modifica' style={{ width: "1em" }} />
                            </div>
                            : <>
                                <div
                                    className={defContinua}
                                    onClick={() => salvaModifiche("sensori")}
                                >
                                    <p>{langSet.salva}</p>
                                    <img src={confirmW} alt='confirmW' style={{ width: "0.8rem", marginLeft: "4px"}} />
                                </div>
                                <div className="selettore selettoreFlex selettoreViolet" onClick={() => { setMod(0); GetSensoriAmbiente() }}>
                                    <p>{langSet.annulla}</p>
                                    <img className="icon-popup" src={close} alt="close" />
                                </div>
                            </>
                        }
                    </div>
                </div>

                {/* SENSORI STANZA */}
                <div style={{ display: status === 3 ? "" : "none" }}>
                    <table id="TitoliLista" >
                        <tbody>
                            <tr>
                                <td width="15%" style={{ border: 0 }}>{langSet.nome} </td>
                                <td width="15%" style={{ border: 0 }}>ID </td>
                                <td width="15%" style={{ border: 0 }}>{langSet.tipo} </td>
                                <td width="15%" style={{ border: 0 }}>{langSet.stato} </td>
                                <td width="15%" style={{ border: 0 }}>{langSet.batteria} </td>
                                <td width="25%" style={{ border: 0 }}></td>
                            </tr>
                        </tbody>
                    </table>
                     <Select id="Select" isDisabled={mod === 0 ? true : false}
                        styles={{
                            control: (provided) => ({ ...provided, width: '300px', fontSize: "90%", color: "#2B318A", fontWeight: "600", borderRadius: "20px", 
                                                    overflowX: "hidden", boxShadow: "none", "&:hover": { borderRadius: "25px", boxShadow: "none", width:"300px" } }),
                            input: (provided) => ({ ...provided, color: "#2B318A", fontWeight: "600", fontSize: "90%", textAlign:"center", marginLeft:"10px" }),
                            menu: (provided) => ({ ...provided, width: '300px', fontSize: "90%", color: "#2B318A", fontWeight: "600", borderRadius: "20px", 
                                                    boxShadow: "none",  border: "solid 1px #2B318A", overflowX: "hidden", 
                                                    "&:hover": { borderRadius: "25px", boxShadow: "none", width:"300px" } }),
                            option: (provided) => ({ ...provided, color: "#2B318A", fontWeight: "600", fontSize: "90%", textAlign:"center", marginLeft:"10px", 
                                                    overflowY: "scroll", maxHeight: "25em", overflowX: "hidden"}),
                            menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999
                            })
                          }}
                        menuPortalTarget={document.body}
                        options={filteredOptionsStanza}
                        value={selectedOption}
                        onChange={(selected) => {setSelectedOption(selected); SensStanza("add", selected.value)}}
                        placeholder={langSet.selezionaSensore}
                        isSearchable
                        onInputChange={(inputValue) => setSearchTerm(inputValue)}
                        /><i style={{ fontSize: "90%", color: "#d3d3d3", display: mod === 1 ? "" : "none" }}>* {langSet.massimo1PerTipologia}</i>
                    <div style={{ overflow: "scroll", maxHeight: "25em" }}>
                        {sensoriStanza.length > 0 ?
                            sensoriStanza.map((sensore, i) => (
                                <table id="Lista" key={i}>
                                    <tbody>
                                        <tr key={sensore}>
                                            <td width="15%" style={{ padding: 0, paddingLeft: ".5em" }}>{sensore.nome}</td>
                                            <td width="15%" style={{ padding: 0, paddingLeft: ".5em" }}>{sensore.id_sensore ?? sensore.id}</td>
                                            <td width="15%" style={{ padding: 0, paddingLeft: ".5em" }}>{sensore.tipo}</td>
                                            <td width="15%" style={{ padding: 0, paddingLeft: ".5em" }}>{sensore.stato}</td>
                                            <td width="15%" style={{ padding: 0, paddingLeft: ".5em" }}>{sensore.batteria}</td>
                                            <td width="25%" style={{ padding: 0, paddingLeft: ".5em" }}>
                                                {mod === 0 ? null :
                                                    <div className="selettore selettoreFlex selettoreViolet" onClick={() => SensStanza("del", sensore.id_sensore)}>
                                                        <p>{langSet.disassocia}</p>
                                                        <img src={delet} alt="delete" />
                                                    </div>
                                                }
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            )) : <p style={{ textAlign: "center", margin: "1em", display: "" }}>{langSet.nessunSensore}</p>
                        }
                    </div>
                    <div className="navigators">
                        {mod === 0 ?
                            <div
                                className="selettore selettoreFlex selettoreViolet"
                                onClick={() => setMod(1)}
                                style={{ display: accountData.tipo === 4 ? "none" : null }}
                            >
                                <p>{langSet.modifica}</p>
                                <img src={modifica} alt='modifica' style={{ width: "1em" }} />
                            </div>
                            : <>
                                <div
                                    className={defContinua}
                                    onClick={() => salvaModifiche("sensori-stanza")}
                                >
                                    <p>{langSet.salva}</p>
                                    <img src={confirmW} alt='confirmW' style={{ width: "0.8rem", marginLeft: "4px"}} />
                                </div>
                                <div className="selettore selettoreFlex selettoreViolet" onClick={() => { setMod(0); GetSensoriStanza() }}>
                                    <p>{langSet.annulla}</p>
                                    <img className="icon-popup" src={close} alt="close" />
                                </div>
                            </>
                        }
                    </div>
                </div>

                {/* ALLARMI PRESENZA */}
                {/* <div style={{ display: status === 4 ? "" : "none" }}>
                    <AllarmiAssenza
                        langSet={langSet}
                        accountData={accountData}
                        allarmiassenzastanza={allarmiassenzaambiente}
                        setAllarmiassenzastanza={setallarmiassenzaambiente}
                        selettoreAllarmiassenzastanza={selettoreAllarmiassenzastanza}
                        allarmiassenzastanzaSwitch={allarmiassenzaambienteSwitch}
                        salvaModifiche={salvaModifiche}
                        modificaType="allarmipresenzaAmbiente"
                        getallarmiassenzastanza={getallarmiassenzaambiente}
                        openProfiloPopup={openProfiloPopup}
                        defContinua={defContinua}
                        mod={mod}
                        setMod={setMod}
                    />
                </div> */}

                {/* ALLARMI CADUTA */}
                <div style={{ display: status === 5 ? "" : "none" }}>
                    <table id="TitoliLista">
                        <tbody>
                            <tr>
                                <td width="15%" style={{ border: 0 }}>{langSet.descrizione}</td>
                                <td width="20%" style={{ border: 0 }}>Da - A</td>
                                <td width="12.5%" style={{ border: 0 }}>Allerta Caduta</td>
                                <td width="62.5%" style={{ border: 0 }}></td>
                            </tr>
                        </tbody>
                    </table>
                    <div style={{ overflow: "scroll", minHeight: "20em", maxHeight: "25em" }}>
                        {allarmiCaduta.length > 0 ?
                            allarmiCaduta.map((allarme, i) => (
                                <table id="Lista" key={i}>
                                    {mod === 0 ?
                                        <tbody>
                                            <tr key={allarme}>
                                                <td width="15%" style={{ padding: 0, paddingLeft: ".5em" }}>{allarme.descrizione}</td>
                                                <td width="20%" style={{ padding: 0, paddingLeft: ".5em" }}>{`${allarme.inizio} - ${allarme.fine}`}</td>
                                                <td width="12.5%" style={{ padding: 0, paddingLeft: ".5em" }}>
                                                    {/*{allarme.stato}*/}
                                                    <Switch
                                                        checked={allarme.stato === "Allarme immediato"}
                                                        onColor="#86d3ff"
                                                        offColor="#cccccc"
                                                        uncheckedIcon={false}
                                                        checkedIcon={false}
                                                        height={24}
                                                        width={48}
                                                        disabled


                                                    />
                                                </td>
                                                <td width="62.5%" style={{ padding: 0, paddingLeft: ".5em" }}>
                                                </td>
                                            </tr>
                                        </tbody>
                                        :
                                        <tbody>
                                            <tr key={allarme}>
                                                <td width="15%" style={{ padding: 0, paddingLeft: ".5em" }}>
                                                    {allarme.id ? allarme.descrizione : <input type="text" placeholder={langSet.inserisciDescrizione} onChange={(e) => { allarmiCaduta[i].descrizione = e.target.value; setAllarmiCaduta([...allarmiCaduta]) }} style={{ width: "85%" }} />}
                                                </td>
                                                <td width="20%" style={{ padding: 0, paddingLeft: ".5em" }}>
                                                    {allarme.id ? <>{allarme.inizio} - {allarme.fine}</> : <><input type="time" style={{ width: "5.25em" }} onChange={(e) => { allarmiCaduta[i].inizio = e.target.value; setAllarmiCaduta([...allarmiCaduta]) }} />&ensp;
                                                        <input type="time" style={{ width: "5.25em" }} onChange={(e) => { allarmiCaduta[i].fine = e.target.value; setAllarmiCaduta([...allarmiCaduta]) }} /></>}
                                                </td>
                                                <td width="12.5%" style={{ padding: 0, paddingLeft: ".5em" }}>

                                                    <Switch
                                                        onChange={(checked) => {
                                                            const newValue = checked ? "Allarme immediato" : "Allarme disabilitato";
                                                            if (allarme.id) {
                                                                allarmiCadutaSwitch(allarme.id, 'edit', newValue);
                                                            }
                                                            allarmiCaduta[i].stato = newValue;
                                                            setAllarmiCaduta([...allarmiCaduta]);
                                                        }}
                                                        checked={allarme.stato === "Allarme immediato"}
                                                        onColor="#86d3ff"
                                                        offColor="#cccccc"
                                                        uncheckedIcon={false}
                                                        checkedIcon={false}
                                                        height={24}
                                                        width={48}
                                                    />

                                                </td>
                                                <td width="62.5%" style={{ padding: 0, paddingLeft: ".5em" }}>
                                                    <div className="selettore selettoreFlex selettoreBorder"
                                                        onClick={() => allarmiCadutaSwitch(allarme.id, 'del')}>
                                                        <p>Elimina</p>
                                                        <img src={delet} alt="delete" />
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    }
                                </table>
                            )) :
                            <p style={{ textAlign: "center", margin: "1em" }}>{langSet.nessunAllarme}</p>
                        }
                    </div>
                    {status === 5 ? profilopopup : null}
                    <div className="navigators">
                        {mod === 0 ?

                            <div className="selettore selettoreFlex selettoreViolet" onClick={() => setMod(1)}
                            >
                                <p>{langSet.modifica}</p>
                                <img src={modifica} alt='modifica' className="icon-popup" style={{ width: "1em" }} />
                            </div>
                            : <>
                                <div className="selettore selettoreFlex selettorePurple normPosition"
                                    onClick={() => allarmiCadutaSwitch('', 'add')}>
                                    <p>{langSet.aggiungi}</p>
                                    <img src={addW} alt="add" className="icon-popup" />
                                </div>
                                <div className={defContinua} onClick={() => salvaModifiche("allarmiCaduta")}>
                                    <p>{langSet.salva}</p>
                                    <img src={confirmW} alt='arrow' className="icon-popup" />
                                </div>
                                <div className="selettore selettoreFlex selettoreViolet" onClick={async () => { await getAllarmiCaduta(); setMod(0); }}>
                                    <p>{langSet.annulla}</p>
                                    <img src={close} alt="close" className="icon-popup" />
                                </div>
                                <div className="selettore selettoreFlex selettoreBorder moblie1" onClick={() => openProfiloPopup("salva")}>
                                    <p>Salva Profilo</p>
                                    <img src={save} alt="save" className="icon-popup" />
                                </div>
                                <div className="selettore selettoreFlex selettoreBorder moblie1" onClick={() => openProfiloPopup("carica")}>
                                    <p>Carica Profilo</p>
                                    <img src={carica} alt="carica" className="icon-popup" />
                                </div>
                            </>
                        }
                    </div>
                </div>

                {/* ALLARMI STANZA */}
                <div style={{ display: status === 6 ? "" : "none" }}>
                    <AllarmiAssenza
                        langSet={langSet}
                        accountData={accountData}
                        allarmiassenzastanza={allarmiassenzastanza}
                        setAllarmiassenzastanza={setallarmiassenzastanza}
                        selettoreAllarmiassenzastanza={selettoreAllarmiassenzastanza}
                        allarmiassenzastanzaSwitch={allarmiassenzastanzaSwitch}
                        salvaModifiche={salvaModifiche}
                        modificaType="allarmipresenzaStanza"
                        getallarmiassenzastanza={getallarmiassenzastanza}
                        openProfiloPopup={openProfiloPopup}
                        defContinua={defContinua}
                        mod={mod}
                        setMod={setMod}
                        sensoriStanza={sensoriStanza}
                    />
                </div>
            </div>

        </>
    );
}

export default SchedaStanza;